export const getSelectedBranchSelector = state => state.slotBooking.selectedBranch;
export const getSelectedBranchId = state => getSelectedBranchSelector(state)?.id;
